"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPunchDateTime = void 0;
const components_1 = require("../../../components");
const getPunchDateTime = (punchCorrectionStatus) => {
    let dateTime, initialDateTime;
    if (!punchCorrectionStatus) {
        return {
            dateTime,
            initialDateTime
        };
    }
    if (punchCorrectionStatus.requestType === components_1.PunchCorrType.EDIT_PUNCH) {
        dateTime = punchCorrectionStatus.newPunchDateTime;
        initialDateTime = punchCorrectionStatus.punchDateTime;
    }
    else {
        dateTime = punchCorrectionStatus.punchDateTime;
    }
    return {
        dateTime,
        initialDateTime
    };
};
exports.getPunchDateTime = getPunchDateTime;
